import axios from 'axios';

/**
 * axios pro backend do marketplace (nginx proxeia /api → :4200).
 * Token do admin fica em localStorage.mkt_token (namespaced pra não
 * colidir com outros apps hospedados no mesmo browser/origin).
 */
const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Redirecionar pro login-admin SOMENTE se a rota atual for admin.
    // Rotas de checkout (/hub/marketplace, /hub/checkout, /hub/checkout/return)
    // NÃO usam token — se receberem 401, é bug de HMAC (não redirecionar).
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith('/plans-admin')) {
        localStorage.removeItem('mkt_token');
        localStorage.removeItem('mkt_user');
        const returnTo = encodeURIComponent(path + window.location.search);
        window.location.href = `/login-admin?returnTo=${returnTo}`;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
